import { ICalendarRenderProps, ISidebarRouteState } from 'components';
import { StageState, UpdateState } from 'enums';
import { IStage, IUpdate } from 'interfaces';
import React, { ReactNode } from 'react';
import { Link } from "react-router-dom";
import cn from 'classnames';

export interface ICalendarLinkProps {
    canConfirmStage: boolean,
    children?: ReactNode,
    isGroupGap: boolean,
    propsFromCalendar: ICalendarRenderProps,
    routeState: ISidebarRouteState,
    stage: IStage,
    title: string,
    update: IUpdate,
}

export function CalendarLink({
    canConfirmStage,
    children,
    isGroupGap,
    propsFromCalendar,
    routeState,
    stage,
    title,
    update,
}: ICalendarLinkProps) {
    const { className, ...otherPropsFromCalendar } = propsFromCalendar;

    return <Link
        to={{
            pathname: '/updates/' + update.id,
            state: routeState,
        }}
        className={cn(className, 'calendarUpdateEvent', {
            'updateState_draft': update.state === UpdateState.Draft,
            'updateState_awaitApproval': update.state === UpdateState.AwaitApproval,
            'updateState_scheduled': update.state === UpdateState.Scheduled,
            'updateState_running': update.state === UpdateState.Running,
            'updateState_canceled': update.state === UpdateState.Canceled,
            'updateState_error': update.state === UpdateState.Error,
            'updateState_done': update.state === UpdateState.Done,

            'stageState_scheduled': !isGroupGap && stage.state === StageState.Scheduled,
            'stageState_running': !isGroupGap && stage.state === StageState.Running,
            'stageState_canceled': !isGroupGap && stage.state === StageState.Canceled,
            'stageState_error': !isGroupGap && stage.state === StageState.Error,
            'stageState_done': !isGroupGap && stage.state === StageState.Done,
            'stage_canConfirmStage': canConfirmStage,
        })}
        title={title}
        {...otherPropsFromCalendar}
    >
        {children}
    </Link>
}